import styled from 'styled-components';
import { rgba } from 'polished';
import { primary, neutral, white } from '../../../../style/colors';

export const Section = styled.div`
  padding: 0;
`;

export const SectionTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: ${neutral[900]};
  margin-bottom: 24px;
  letter-spacing: -0.3px;
`;

export const ContentLayout = styled.div`
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 30px;
  margin-bottom: 20px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const VisualLabelContainer = styled.div`
  background: ${white};
  border: 2px solid ${neutral[200]};
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

export const VisualLabel = styled.div`
  width: 100%;
  max-width: 250px;
  aspect-ratio: 0.7;
  background: linear-gradient(135deg, ${neutral[100]} 0%, ${white} 100%);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border: 1px solid ${neutral[300]};
  position: relative;
  overflow: hidden;

  &:before {
    content: 'EU';
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
    font-weight: 700;
    color: #003399;
  }
`;

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  margin: 8px 0;
  background: ${white};
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
`;

export const LabelIcon = styled.i`
  font-size: 20px;
  color: ${primary[500]};
  margin-right: 10px;
`;

export const LabelText = styled.span`
  font-size: 12px;
  color: ${neutral[500]};
  flex: 1;
`;

const getRatingColor = (rating) => {
  const upper = rating?.toUpperCase();
  if (upper === 'A') return '#00b050';
  if (upper === 'B') return '#92d050';
  if (upper === 'C') return '#ffff00';
  if (upper === 'D') return '#ffc000';
  if (upper === 'E') return primary[500];
  return neutral[500];
};

export const LabelRating = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${props => getRatingColor(props.rating)};
  min-width: 40px;
  text-align: center;
`;

export const LabelGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
`;

export const LabelCard = styled.div`
  background: ${neutral[50]};
  padding: 16px 18px;
  border-radius: 10px;
  border: 1px solid ${neutral[200]};
  transition: all 0.2s ease;
  position: relative;
  cursor: help;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px ${rgba(primary[500], 0.15)};
    border-color: ${primary[500]};
  }
`;

export const LabelName = styled.div`
  font-size: 12px;
  color: ${primary[500]};
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 6px;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  gap: 6px;

  i {
    font-size: 14px;
  }
`;

export const LabelValue = styled.div`
  font-size: 16px;
  color: ${neutral[900]};
  font-weight: 600;
`;

export const Tooltip = styled.div`
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  background: ${neutral[700]};
  color: ${white};
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  opacity: ${props => props.visible ? '1' : '0'};
  pointer-events: none;
  transition: opacity 0.2s ease;
  z-index: 10;
  max-width: 250px;
  white-space: normal;
  text-align: center;

  &:after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: ${neutral[700]};
  }
`;

export const Link = styled.a`
  color: ${primary[500]};
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 24px;
  padding: 10px 16px;
  border-radius: 8px;
  background: ${primary[50]};
  border: 1px solid ${primary[200]};
  transition: all 0.2s ease;

  &:hover {
    background: ${primary[100]};
    border-color: ${primary[500]};
    transform: translateX(2px);
  }
`;
